import {
  LOGIN,
  LOGOUT,
  PASSWORD_RESET_INIT,
  PASSWORD_RESET_SENT,
  SET_TEMP_PASSWORD,
  CLEAR_TEMP_PASSWORD
} from 'actions/authActions';

const initialState = {
  loggedIn: false,
  authData: null,
  passwordResetSent: false,
  tempPassword: null
};

export default function auth (state = initialState, action) {
  const { authData, tempPassword } = action;
  switch (action.type) {
  case LOGIN:
    return {
      ...state,
      loggedIn: true,
      authData
    };
  case LOGOUT:
    return { ...initialState };
  case SET_TEMP_PASSWORD:
    return {
      ...state,
      tempPassword
    };
  case CLEAR_TEMP_PASSWORD:
    return {
      ...state,
      tempPassword: null
    };
  case PASSWORD_RESET_INIT:
    return { ...state,
      passwordResetSent: false
    };
  case PASSWORD_RESET_SENT:
    return { ...state,
      passwordResetSent: true
    };
  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/authReducer.js